import { getYearIso, getWeekNumber } from '.';

export default function getWeekUrl(date) {
    const year = getYearIso(date);
    const week = getWeekNumber(date);
    return `${year}/${week}`;
}
